import React, { useEffect, useState } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  Modal,
  Image,
  InputGroup,
  FormControl,
  Table, Button
} from "react-bootstrap";
import { Breadcrumbs, TableRow, Typography } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { NavLink, useHistory } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import {
  ErrorImg,
  base_url,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Ringbildermenu from "../../Components/ringbildermenu";
import ReplayIcon from "@mui/icons-material/Replay";
import { Skeleton } from "@mui/material";
import { isMobileOnly, isTablet } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import ListIcon from "@mui/icons-material/List";
import AppsIcon from "@mui/icons-material/Apps";
import IonRangeSlider from 'react-ion-slider';
import { store } from "../../Store/store";
import { sessionId } from "../../Reducer/homeReducer";
import ShopStyle from '../../Assets/css/RingDiamondShop.module.css'
import vline from '../../Assets/newImg/vline.png'
const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const Gemstone = (props) => {
  const history = useHistory();
  const session_Id = useSelector(state => state.persistedReducer.home.session_id);
  const [view, setView] = useState(1);
  const [productCount, setProductCount] = useState(0);
  const [page, setPage] = useState(1);
  const [gemstoneList, setGemstoneList] = useState([]);
  const [stone, setStone] = useState(
    JSON.parse(sessionStorage.getItem("bw_g_filter"))?.stone
      ? JSON.parse(sessionStorage.getItem("bw_g_filter"))?.stone
      : ""
  );
  const [color, setColor] = useState(
    JSON.parse(sessionStorage.getItem("bw_g_filter"))?.color
      ? JSON.parse(sessionStorage.getItem("bw_g_filter"))?.color
      : ""
  );
  const [shape, setShape] = useState(
    JSON.parse(sessionStorage.getItem("bw_g_filter"))?.shape
      ? JSON.parse(sessionStorage.getItem("bw_g_filter"))?.shape
      : ""
  );
  const [caratrange, setCaratrange] = useState([]);
  const [carat, setCarat] = useState(
    JSON.parse(sessionStorage.getItem("bw_g_filter"))?.carat
      ? JSON.parse(sessionStorage.getItem("bw_g_filter"))?.carat
      : []
  );
  const [pricerange, setPricerange] = useState([]);
  const [price, setPrice] = useState(
    JSON.parse(sessionStorage.getItem("bw_g_filter"))?.price
      ? JSON.parse(sessionStorage.getItem("bw_g_filter"))?.price
      : []
  );
  const [leavemouse, setLeavemouse] = useState(false);
  const [filter, setFilter] = useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [sortby, setSortby] = useState("");
  const [inputchange, setInputchange] = useState(false);
  const [clearFdata, setClearFdata] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.location.pathname?.includes('/gemstones/shape=')) {
      setShape(props.location.pathname?.replace('/gemstones/shape=', ""))
    } else if (props.location.pathname?.includes('/gemstones/color=')) {
      setColor(props.location.pathname?.replace('/gemstones/color=', ""))
    } else if (props.location.pathname?.includes('/gemstones/stone=')) {
      setStone(props.location.pathname?.replace('/gemstones/stone=', ""))
    }
  }, [props.location.pathname])
  const clearFilter = () => {
    sessionStorage.removeItem("bw_g_filter");
    setShape("");
    setCarat([
      filter?.normal_filters?.carat?.min,
      filter?.normal_filters?.carat?.max,
    ]);
    setPrice([
      filter?.normal_filters?.price?.min,
      filter?.normal_filters?.price?.max,
    ]);
    setColor("");
    setStone("");
    setSortby(filter?.sort_by[0]?.value);
    setClearFdata(!clearFdata);
  };

  useEffect(() => {
    setSteps(2);
    setFiltersuccess(false);
    const data = {
      currency_code: currencycode,
      setting_id: JSON.parse(localStorage.getItem("bw-settingdata"))
        ? JSON.parse(localStorage.getItem("bw-settingdata"))?.product_id
        : "",
    };
    axios
      .post(base_url + "/diamond/gemstone_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFilter(res.data.data);
          setSortby(res.data.data?.sort_by[0]?.value);
          if (
            !JSON.parse(sessionStorage.getItem("bw_g_filter"))?.price.length
          ) {
            setPrice([
              res.data.data?.normal_filters?.price?.min,
              res.data.data?.normal_filters?.price?.max,
            ]);
          }
          if (
            !JSON.parse(sessionStorage.getItem("bw_g_filter"))?.carat.length
          ) {
            setCarat([
              res.data.data?.normal_filters?.carat?.min,
              res.data.data?.normal_filters?.carat?.max,
            ]);
          }
          res.data.data?.normal_filters?.color?.map((val) =>
            val.selected == 1 ? setColor(val.value) : ""
          );
          res.data.data?.normal_filters?.stone_type?.map((val) =>
            val.selected == 1 ? setStone(val.value) : ""
          );
          res.data.data?.normal_filters?.shape?.map((val) =>
            val.selected == 1 ? setShape(val.value) : ""
          );
          setCaratrange(res.data.data?.normal_filters?.carat?.range)
          setPricerange(res.data.data?.normal_filters?.price?.range)
          setFiltersuccess(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    localStorage.removeItem("bw-diamonddata");
    localStorage.removeItem("bw-fancycolordata");
  }, []);

  useEffect(() => {
    onchangesdata();
  }, [shape, color, stone, sortby, inputchange, clearFdata, carat, price]);

  useEffect(() => {
    if (filtersuccess) {
      gemstonelistdata();
    }
  }, [page, filtersuccess]);

  const onchangesdata = () => {
    setPage(1);
    var data1 = {
      shape,
      carat,
      price,
      color,
      stone,
      sortby,
    };
    sessionStorage.setItem("bw_g_filter", JSON.stringify(data1));
    if (filtersuccess) {
      gemstonelistdata();
    }
  };

  const gemstonelistdata = () => {
    setLoader(true);
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 16,
      length: 16,
      color: color,
      shape,
      stone_type: stone,
      price_to: price[1],
      price_from: price[0],
      carat_from: carat[0],
      carat_to: carat[1],
      sort_by: sortby,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      token: isLogin ? user.token : "",
      diamond_type: 3,
    };
    axios
      .post(base_url + "/diamond/gemstone_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setTotalCount(res.data.data?.count);
          var count = (res.data.data?.count / 16).toFixed();
          if (count * 16 >= res.data.data?.count) {
            setProductCount(count);
          } else {
            setProductCount(Number(count) + 1);
          }
          setGemstoneList(res.data.data?.result);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleprice = (value) => {
    setPrice([value.from_value, value.to_value]);
  };
  const handlepriceinput = (i) => {
    var data = [];
    if (i == 0) {
      if (price[0] < filter?.normal_filters?.price?.min) {
        data = [filter?.normal_filters?.price?.min, price[1]];
      } else if (price[0] > filter?.normal_filters?.price?.max) {
        data = [filter?.normal_filters?.price?.max, price[1]];
      } else {
        data = [price[0], price[1]];
      }
    } else if (i == 1) {
      if (price[1] > filter?.normal_filters?.price?.max) {
        data = [price[0], filter?.normal_filters?.price?.max];
      } else if (price[1] < filter?.normal_filters?.price?.min) {
        data = [price[0], filter?.normal_filters?.price?.min];
      } else {
        data = [price[0], price[1]];
      }
    }
    console.log(data);
    if (data[0] < data[1]) {
      var data1 = [data[0], data[1]];
    } else {
      var data1 = [data[1], data[0]];
    }
    setPrice(data1);
    setInputchange(!inputchange);
  };
  const handlecarat = (value) => {
    setCarat([value.from_value, value.to_value]);
  };
  const handlecaratinput = (i) => {
    var data = [];
    if (i == 0) {
      if (carat[0] < filter?.normal_filters?.carat?.min) {
        data = [filter?.normal_filters?.carat?.min, carat[1]];
      } else if (carat[0] > filter?.normal_filters?.carat?.max) {
        data = [filter?.normal_filters?.carat?.max, carat[1]];
      } else {
        data = [carat[0], carat[1]];
      }
    } else if (i == 1) {
      if (carat[1] > filter?.normal_filters?.carat?.max) {
        data = [carat[0], filter?.normal_filters?.carat?.max];
      } else if (carat[1] < filter?.normal_filters?.carat?.min) {
        data = [carat[0], filter?.normal_filters?.carat?.min];
      } else {
        data = [carat[0], carat[1]];
      }
    }
    if (data[0] < data[1]) {
      var data1 = [Number(data[0]), Number(data[1])];
    } else {
      var data1 = [Number(data[1]), Number(data[0])];
    }
    setCarat(data1);
    setInputchange(!inputchange);
  };
  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  $(document).ready(function () {
    $("#ringsettingtable").DataTable();
  });
  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: product_id?.stock_no,
      type: "gemstone",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = gemstoneList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setGemstoneList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push("/");
          window.location.reload(true);
        } else {
          console.log(res.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [expanded, setExpanded] = React.useState(false);
  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
        <link rel="canonical" href={window.location.href}></link>
      </Helmet>

      {/* <div className={ShopStyle.BannerTop}>
        <h3 className={ShopStyle.subTitle}>GEMSTONES</h3>
        <h2 className={ShopStyle.Title}>Gemstone Search</h2>
        <ul className={ShopStyle.BreadcrumbS}>
          <li><a href='/'>Home</a></li>
          <li>/</li>
          <li>Gemstone Search</li>
        </ul>
      </div> */}

      <Ringbildermenu location="gemstone" />

      <div className="rcs_ringsetting_section mt-3">
        <Container fluid className="rcs_shap-wizard_container">
          <div className={ShopStyle.MainBoxRingDiamondShop}>
            <div className={ShopStyle.LeftContainer}>
              <div className={ShopStyle.titlebox}>
                <h3 className={ShopStyle.Title}>Filters</h3>
                <Button
                  variant="outlined"
                  onClick={clearFilter}
                  className={ShopStyle.ShowcaseClearFilter}
                >
                  <ReplayIcon /> Reset
                </Button>
              </div>

              <div className={"rcs_diamond_filter_section rcs_diamond_filter_section_desktop mt-3 " + ShopStyle.FilterBox}>
                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Gemstone Type" className={ShopStyle.FilterBoxTitle}>Gemstone Type</h2>
                  )}
                  <ul class={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_shape1 " + ShopStyle.FilterBoxIcons}>
                    {!filtersuccess ? (
                      <>
                        {[...Array(10)]?.map((val) =>
                          isTablet ? (
                            <Skeleton
                              className="mb-2"
                              variant="text"
                              style={{ transform: "unset", margin: "0 10px" }}
                              animation="wave"
                              width={80}
                              height={35}
                            />
                          ) : (
                            <Skeleton
                              className="mb-2"
                              variant="text"
                              style={{ transform: "unset", margin: "0 10px" }}
                              animation="wave"
                              width={129}
                              height={92}
                            />
                          )
                        )}
                      </>
                    ) : (
                      <>
                        {filter?.normal_filters?.stone_type?.map((val) => (
                          <li
                            data-qa="TypeFilter-BlueSapphire"
                            onClick={() =>
                              stone == val.value
                                ? setStone("")
                                : setStone(val.value)
                            }
                            className={
                              val.status
                                ? stone == val.value
                                  ? "item--YBPgi selected--Qs8si " + ShopStyle.active
                                  : "item--YBPgi"
                                : "item--YBPgi diamond-filter-dis"
                            }
                          >
                            <span class="single-item-container--Xo5ic">
                              <img className="gemstonList_Filter_type"
                                src={val.icon}
                                alt={val.name}
                              ></img>
                              <span className={"title--jqbwB " + ShopStyle.shapeTitle} data-value="20">{val.name}</span>
                            </span>
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Gemstone Color" className={ShopStyle.FilterBoxTitle}>Color</h2>
                  )}

                  <ul class={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color " + ShopStyle.FilterBoxIcons}>
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            className="mb-2"
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      filter?.normal_filters?.color?.map((val) => (
                        <li
                          data-qa="TypeFilter-BlueSapphire"
                          onClick={() =>
                            color == val.value
                              ? setColor("")
                              : setColor(val.value)
                          }
                          className={
                            val.status
                              ? color == val.value
                                ? "item--YBPgi selected--Qs8si " + ShopStyle.active
                                : "item--YBPgi"
                              : "item--YBPgi diamond-filter-dis"
                          }
                        >
                          <span class="single-item-container--Xo5ic">
                            <span class={"title--jqbwB " + ShopStyle.shapeTitle}>{val.name}</span>
                            <div class="filtered--yd5Rg"></div>
                            <Image src={val.icon} alt={val.name}></Image>
                          </span>
                        </li>
                      ))
                    )}
                  </ul>

                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Gemstone Carat" className={ShopStyle.FilterBoxTitle}>Carat</h2>
                  )}

                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={'100%'}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        <IonRangeSlider type="double"
                          min={filter?.normal_filters?.carat?.min}
                          max={filter?.normal_filters?.carat?.max}
                          values={caratrange}
                          // onChange={handlecarat}
                          onFinish={(e) => handlecarat(e)}
                          from={caratrange.indexOf(carat[0])}
                          to={caratrange.indexOf(carat[1])}
                        />
                      </div>
                      <Row className="mt-2">
                        <ul className="rcs_price_range_input rcs_prince_input_diamond">
                          <li>
                            <InputGroup>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="number"
                                step={0.01}
                                min={0}
                                name="min"
                                value={carat[0]}
                                onChange={(e) => {
                                  if (caratrange.includes(e.target.value)) {
                                    setCarat([
                                      Number(e.target.value),
                                      Number(carat[1]),
                                    ])
                                  } else {
                                    var ind = caratrange.find(val => { return val > e.target.value })
                                    caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                    setCarat([
                                      Number(e.target.value),
                                      Number(carat[1]),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlecaratinput(0)}
                              />
                            </InputGroup>
                          </li>
                          <li>
                            <InputGroup>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="number"
                                step={0.01}
                                min={0}
                                name="max"
                                value={carat[1]}
                                onChange={(e) => {
                                  if (caratrange.includes(e.target.value)) {
                                    setCarat([
                                      Number(carat[0]),
                                      Number(e.target.value),
                                    ])
                                  } else {
                                    var ind = caratrange.find(val => { return val > e.target.value })
                                    caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                    setCarat([
                                      Number(carat[0]),
                                      Number(e.target.value),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlecaratinput(1)}
                              />
                            </InputGroup>
                          </li>
                        </ul>
                      </Row>
                    </>
                  )}
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Gemstone Shape" className={ShopStyle.FilterBoxTitle}>Shape</h2>
                  )}

                  <ul className={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_shape " + ShopStyle.FilterBoxIcons}>
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            className="mb-2"
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      filter?.normal_filters?.shape?.map((val) => (
                        <li
                          data-qa="ShapeFilter-Round"
                          onClick={() =>
                            shape == val.value
                              ? setShape("")
                              : setShape(val.value)
                          }
                          className={
                            val.status
                              ? shape == val.value
                                ? "longFilter--VqAB5 item--YBPgi selected--Qs8si " + ShopStyle.active
                                : "longFilter--VqAB5 item--YBPgi"
                              : "longFilter--VqAB5 item--YBPgi diamond-filter-dis"
                          }
                        >
                          <span className="single-item-container--Xo5ic">
                            <span className={"title--jqbwB " + ShopStyle.shapeTitle}>{val.name}</span>
                            <div className="filtered--yd5Rg"></div>
                            <img src={val.icon} alt="" />
                          </span>
                        </li>
                      ))
                    )}
                  </ul>
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Gemstone Price" className={ShopStyle.FilterBoxTitle}>Price</h2>
                  )}

                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          className="mb-2"
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={'100%'}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        <IonRangeSlider type="double"
                          min={filter?.normal_filters?.price?.min}
                          max={filter?.normal_filters?.price?.max}
                          values={pricerange}
                          // onChange={handleprice}
                          onFinish={(e) => handleprice(e)}
                          from={pricerange.indexOf(price[0])}
                          to={pricerange.indexOf(price[1])}
                        />
                      </div>
                      <Row className="mt-2">
                        <ul className="rcs_price_range_input rcs_prince_input_diamond">
                          <li className="rcs_price_range_input1">
                            <InputGroup>
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="min"
                                value={price[0]}
                                onChange={(e) => {
                                  if (pricerange.includes(e.target.value)) {
                                    setPrice([
                                      Number(e.target.value),
                                      Number(price[1]),
                                    ])
                                  } else {
                                    var ind = pricerange.find(val => { return val > e.target.value })
                                    pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                    setPrice([
                                      Number(e.target.value),
                                      Number(price[1]),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlepriceinput(0)}
                              />
                            </InputGroup>
                          </li>
                          <li className="rcs_price_range_input1">
                            <InputGroup>
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="max"
                                value={price[1]}
                                onChange={(e) => {
                                  if (pricerange.includes(e.target.value)) {
                                    setPrice([
                                      Number(price[0]),
                                      Number(e.target.value),
                                    ])
                                  } else {
                                    var ind = pricerange.find(val => { return val > e.target.value })
                                    pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                    setPrice([
                                      Number(price[0]),
                                      Number(e.target.value),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlepriceinput(1)}
                              />
                            </InputGroup>
                          </li>
                        </ul>
                      </Row>
                    </>
                  )}
                </div>
              </div>


              <div className="rcs_diamond_filter_section d-block d-md-none">
                <div
                  className="rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
                >
                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleChangeAccordion("panel1")}
                  >
                    <AccordionSummary
                      className={ShopStyle.AdvaFilter}
                      style={{ width: "100%" }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>
                        <span>Gemstones Type</span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="pt-0 pb-0">
                      <div className={ShopStyle.FilterBox}>
                        <div className={ShopStyle.FilterBox_inner + ' '}>
                          <ul className={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_shape1 " + ShopStyle.FilterBoxIcons}>
                            {filter?.normal_filters?.stone_type?.map((val) => (
                              <li
                                data-qa="TypeFilter-BlueSapphire"
                                onClick={() =>
                                  stone == val.value
                                    ? setStone("")
                                    : setStone(val.value)
                                }
                                className={
                                  val.status
                                    ? stone == val.namvaluee
                                      ? "item--YBPgi selected--Qs8si " + ShopStyle.active
                                      : "item--YBPgi"
                                    : "item--YBPgi diamond-filter-dis"
                                }
                              >
                                <span class="single-item-container--Xo5ic">
                                  <img
                                    style={{
                                      width: "55px",
                                      margin: "0 auto 10px",
                                    }}
                                    src={val.icon}
                                    alt={val.name}
                                  ></img>
                                  <span className={"title--jqbwB " + ShopStyle.shapeTitle} data-value="20">{val.name}</span>
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
                <div
                  className="rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
                >
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChangeAccordion("panel2")}
                  >
                    <AccordionSummary
                      className={ShopStyle.AdvaFilter}
                      style={{ width: "100%" }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography>
                        <span>Gemstones Filter</span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="pt-0 pb-0">
                      <Typography className=" mt-3">
                        <div className={ShopStyle.FilterBox}>
                          <div className={ShopStyle.FilterBox_inner + ' '}>
                            <h2 title="Gemstone Color" className={ShopStyle.FilterBoxTitle}>Color</h2>
                            <ul className={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_mob " + ShopStyle.FilterBoxIcons}>
                              {filter?.normal_filters?.color?.map((val) => (
                                <li
                                  data-qa="TypeFilter-BlueSapphire"
                                  onClick={() =>
                                    color == val.value
                                      ? setColor("")
                                      : setColor(val.value)
                                  }
                                  className={
                                    val.status
                                      ? color == val.value
                                        ? "item--YBPgi selected--Qs8si " + ShopStyle.active
                                        : "item--YBPgi"
                                      : "item--YBPgi diamond-filter-dis"
                                  }
                                >
                                  <span class="single-item-container--Xo5ic">
                                    <span className={"title--jqbwB " + ShopStyle.shapeTitle}>{val.name}</span>
                                    <div class="filtered--yd5Rg"></div>
                                    <Image src={val.icon} alt={val.name}></Image>
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox}>
                          <div className={ShopStyle.FilterBox_inner + ' '}>
                            <h2 title="Gemstone Shape" className={ShopStyle.FilterBoxTitle}>Shape</h2>
                            <ul className={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_shape " + ShopStyle.FilterBoxIcons}>
                              {filter?.normal_filters?.shape?.map((val) => (
                                <li
                                  data-qa="ShapeFilter-Round"
                                  onClick={() =>
                                    shape == val.value
                                      ? setShape("")
                                      : setShape(val.value)
                                  }
                                  className={
                                    val.status
                                      ? shape == val.value
                                        ? "longFilter--VqAB5 item--YBPgi selected--Qs8si " + ShopStyle.active
                                        : "longFilter--VqAB5 item--YBPgi"
                                      : "longFilter--VqAB5 item--YBPgi diamond-filter-dis"
                                  }
                                >
                                  <span className="single-item-container--Xo5ic">
                                    <span className={"title--jqbwB " + ShopStyle.shapeTitle}>
                                      {val.name}
                                    </span>
                                    <div className="filtered--yd5Rg"></div>
                                    <img src={val.icon}></img>
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox}>
                          <div className={ShopStyle.FilterBox_inner + ' '}>
                            <h2 title="Gemstone Carat" className={ShopStyle.FilterBoxTitle}>Carat</h2>
                            <div className="rcs_catat_slider">
                              <IonRangeSlider type="double"
                                min={filter?.normal_filters?.carat?.min}
                                max={filter?.normal_filters?.carat?.max}
                                values={caratrange}
                                // onChange={handlecarat}
                                onFinish={(e) => handlecarat(e)}
                                from={caratrange.indexOf(carat[0])}
                                to={caratrange.indexOf(carat[1])}
                              />
                            </div>
                            <Row className="mt-2">
                              <ul className="rcs_price_range_input rcs_prince_input_diamond">
                                <li>
                                  <InputGroup>
                                    <FormControl
                                      aria-label="Amount (to the nearest dollar)"
                                      type="number"
                                      step={0.01}
                                      min={0}
                                      name="min"
                                      value={carat[0]}
                                      onChange={(e) => {
                                        if (caratrange.includes(e.target.value)) {
                                          setCarat([
                                            Number(e.target.value),
                                            Number(carat[1]),
                                          ])
                                        } else {
                                          var ind = caratrange.find(val => { return val > e.target.value })
                                          caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                          setCarat([
                                            Number(e.target.value),
                                            Number(carat[1]),
                                          ])
                                        }
                                      }
                                      }
                                      onBlurCapture={() => handlecaratinput(0)}
                                    />
                                  </InputGroup>
                                </li>
                                <li>
                                  <InputGroup>
                                    <FormControl
                                      aria-label="Amount (to the nearest dollar)"
                                      type="number"
                                      step={0.01}
                                      min={0}
                                      name="max"
                                      value={carat[1]}
                                      onChange={(e) => {
                                        if (caratrange.includes(e.target.value)) {
                                          setCarat([
                                            Number(carat[0]),
                                            Number(e.target.value),
                                          ])
                                        } else {
                                          var ind = caratrange.find(val => { return val > e.target.value })
                                          caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                          setCarat([
                                            Number(carat[0]),
                                            Number(e.target.value),
                                          ])
                                        }
                                      }
                                      }
                                      onBlurCapture={() => handlecaratinput(1)}
                                    />
                                  </InputGroup>
                                </li>
                              </ul>
                            </Row>
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox}>
                          <div className={ShopStyle.FilterBox_inner + ' '}>
                            <h2 title="Gemstone Price" className={ShopStyle.FilterBoxTitle}>Price</h2>
                            <div className="rcs_catat_slider">

                              <IonRangeSlider type="double"
                                min={filter?.normal_filters?.price?.min}
                                max={filter?.normal_filters?.price?.max}
                                values={pricerange}
                                // onChange={handleprice}
                                onFinish={(e) => handleprice(e)}
                                from={pricerange.indexOf(price[0])}
                                to={pricerange.indexOf(price[1])}
                              />
                            </div>
                            <Row className="mt-2">
                              <ul className="rcs_price_range_input rcs_prince_input_diamond">
                                <li className="rcs_price_range_input1">
                                  <InputGroup>
                                    <InputGroup.Text>{currency}</InputGroup.Text>
                                    <FormControl
                                      aria-label="Amount (to the nearest dollar)"
                                      type="int"
                                      name="min"
                                      value={price[0]}
                                      onChange={(e) => {
                                        if (pricerange.includes(e.target.value)) {
                                          setPrice([
                                            Number(e.target.value),
                                            Number(price[1]),
                                          ])
                                        } else {
                                          var ind = pricerange.find(val => { return val > e.target.value })
                                          pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                          setPrice([
                                            Number(e.target.value),
                                            Number(price[1]),
                                          ])
                                        }
                                      }
                                      }
                                      onBlurCapture={() => handlepriceinput(0)}
                                    />
                                  </InputGroup>
                                </li>
                                <li className="rcs_price_range_input1">
                                  <InputGroup>
                                    <InputGroup.Text>{currency}</InputGroup.Text>
                                    <FormControl
                                      aria-label="Amount (to the nearest dollar)"
                                      type="int"
                                      name="max"
                                      value={price[1]}
                                      onChange={(e) => {
                                        if (pricerange.includes(e.target.value)) {
                                          setPrice([
                                            Number(price[0]),
                                            Number(e.target.value),
                                          ])
                                        } else {
                                          var ind = pricerange.find(val => { return val > e.target.value })
                                          pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                          setPrice([
                                            Number(price[0]),
                                            Number(e.target.value),
                                          ])
                                        }
                                      }
                                      }
                                      onBlurCapture={() => handlepriceinput(1)}
                                    />
                                  </InputGroup>
                                </li>
                              </ul>
                            </Row>
                          </div>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>

            </div>

            <div className={ShopStyle.RightContainer}>
              {/* <Ringbildermenu location="gemstone" /> */}

              <div className="rcs_product_list_wrapper ">
                <div className={"rcs_view " + ShopStyle.TopviewProductsBox}>
                  <div className={"rcs_mob_filter1 rcs_ring_setting_filter " + ShopStyle.TopviewProductsBoxLeft}>
                    {loader ? (
                      <>
                        <Skeleton
                          variant="text"
                          animation="wave"
                          className="m-auto"
                          width={150}
                          height={20}
                        />
                      </>
                    ) : (
                      <span>  {totalCount} Product(s) Found </span>
                    )}
                  </div>


                  <div className={ShopStyle.TopviewProductsBoxRight}>
                    <div className={"rcs_mob_filter1 rcs_ring_setting_filter1 " + ShopStyle.TopviewProductsviewIcon}>
                      <span className={ShopStyle.TopviewProductsBoxtitle}> View</span>
                      {/* <AppsIcon
                        className={view == 1 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(1)}
                      /> */}
                      <svg className={view == 1 ? "active_grid" : " "}
                        onClick={() => setView(1)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H8.57143V8.57143H0V0ZM11.4286 0H20V8.57143H11.4286V0ZM8.57143 11.4286H0V20H8.57143V11.4286ZM11.4286 11.4286H20V20H11.4286V11.4286Z" fill="none" />
                      </svg>
                      <span style={{ borderRight: "1px solid #ccc" }}></span>
                      {/* <ListIcon
                        className={view == 2 ? "active_grid ml-2" : "ml-2"}
                        onClick={() => setView(2)}
                      /> */}

                      <svg className={view == 2 ? "active_grid" : " "}
                        onClick={() => setView(2)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H4V4H0V0ZM6.00028 0H20.0003V4H6.00028V0ZM4 8.00014H0V12.0001H4V8.00014ZM0 16.0003H4V20.0003H0V16.0003ZM20.0003 8.00014H6.00028V12.0001H20.0003V8.00014ZM6.00028 16.0003H20.0003V20.0003H6.00028V16.0003Z" fill="none" />
                      </svg>

                    </div>
                    <img src={vline} alt="" className={ShopStyle.TopviewProductsVline} />

                    <div
                      className={
                        isMobileOnly
                          ? "rcs_sort_filter p-0 " + ShopStyle.TopviewProductsshortBy
                          : "rcs_sort_filter p-0 " + ShopStyle.TopviewProductsshortBy
                      }
                    >
                      <label>

                        <span className={ShopStyle.TopviewProductsshortByTitle}>Sort By
                          {/* <i>Featured</i>  */}
                        </span>
                      </label>
                      <Form.Select
                        onChange={(e) => {
                          setSortby(e.target.value);
                          window.scrollTo(0, 0);
                        }}
                        value={sortby}
                        aria-label="Default select example"
                      >
                        {filter.sort_by?.map((val) => (
                          <option value={val.value}>{val.name}</option>
                        ))}
                      </Form.Select>
                    </div>

                  </div>


                </div>
              </div>
              {view == 2 ? (
                <Row className="w-100 d-block m-auto">
                  <Col xs={12} className="rcs_diamond_table p-0">
                    <Table
                      hover
                      responsive
                      size="sm"
                      className="rcs_diamonds_table"
                    >
                      <thead>
                        <tr>
                          <th>Stone Type</th>
                          <th>Shape</th>
                          <th>Carat</th>
                          {isMobileOnly ? ' ' :
                            <>
                              <th>Color</th>
                              <th>Clarity</th>
                              <th>Cut</th></>
                          }
                          <th>Price</th>
                          <th>{isMobileOnly ? ' ' : 'Wishlist' }</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {loader ? (
                          <>
                            {[...Array(15)]?.map((val) => (
                              <tr>
                                <td component="th" scope="row">
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          gemstoneList?.map((row, index) => (
                            <tr>
                              <td>{row.stone_type}</td>
                              <td>{row.shape}</td>
                              <td>{row.weight}</td>
                              {isMobileOnly ? '' :
                                <>
                                  <td>{row.color}</td>
                                  <td>{row.clarity}</td>
                                  <td>{row.cut_grade}</td>
                                </>
                              }
                              <td style={{ fontWeight: "600" }}>
                                {currency}
                                {row.sale_price}
                              </td>
                              <td
                                title="Add to Wishlist"
                                style={{ cursor: "pointer",textAlign: 'center' }}
                              >
                                {row.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() => addtowishlist(row, index)}
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() => addtowishlist(row, index)}
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </td>
                              <td>
                                <Button
                                  onClick={() =>
                                    history.push(
                                      "/gemstone-details/" + row.stock_no
                                    )
                                  }
                                  variant="contained"
                                >
                                  Details
                                </Button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    <Stack spacing={2} className="mt-3 mb-3 rcs_diamond_pagination">
                      <Pagination
                        count={productCount}
                        page={page}
                        onChange={handlePageChange}
                        shape="rounded"
                      />
                    </Stack>
                  </Col>
                </Row>
              ) : (
                <>
                  <Row>
                    {loader ? (
                      <>
                        {[...Array(15)].map((val) => (
                          <>
                            <Col xs={6} sm={6} md={4} lg={4} xl={4} className={ShopStyle.Col_box}>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                  marginBottom: "15px",
                                }}
                                animation="wave"
                                height={300}
                              />
                            </Col>
                          </>
                        ))}
                      </>
                    ) : (
                      gemstoneList?.map((row, index) => (
                        <Col xs={6} sm={6} md={4} lg={4} xl={4} className={ShopStyle.Col_box}>
                          <div className="rcs_diamonds_grid_content">
                            {/* <span className="rcs_diamonds_grid_info" >
                                        <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                            {/* <span
                                className="rcs_diamonds_grid_wishlist"
                                style={{ cursor: "pointer" }}
                              >
                                {row.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() => addtowishlist(row, index)}
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() => addtowishlist(row, index)}
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </span> */}
                            <div className={ShopStyle.HoverBox}>
                              <NavLink to={"/gemstone-details/" + row.stock_no}>
                                <img src={row.imagelink} id={row.stock_no} onError={() => ErrorImg("Gemstone", row.stock_no)} alt="gemstone" className />
                              </NavLink>

                              <div className="rcs_product_tooltip">
                                {/* <span>
                                  <MoreVertOutlinedIcon />
                                </span> */}
                                <div className="rcs_product_tooltip_content">
                                  <div className="rcs_bg-slide">
                                    <div className={ShopStyle.HoverBoxIcons}>
                                      <div className={ShopStyle.HoverBoxWishlist}>

                                        {row.is_wishlist == "0" ? <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist11} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g filter="url(#filter0_d_1_256)">
                                            <circle cx="43" cy="43" r="23" fill="white" />
                                          </g>
                                          <path d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z" stroke="#14344A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                          <defs>
                                            <filter id="filter0_d_1_256" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite in2="hardAlpha" operator="out" />
                                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_256" />
                                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_256" result="shape" />
                                            </filter>
                                          </defs>
                                        </svg>
                                          :
                                          <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist21} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_259)">
                                              <circle cx="43" cy="43" r="23" fill="#607980" />
                                            </g>
                                            <path d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z" fill="white" />
                                            <defs>
                                              <filter id="filter0_d_1_259" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_259" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_259" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>
                                        }
                                      </div>
                                      <div className={ShopStyle.HoverBoxWishlist}>

                                        <NavLink to={"/gemstone-details/" + row.stock_no}>
                                          <svg className={ShopStyle.HoverBoxWishlist1} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_251)">
                                              <circle cx="43" cy="43" r="23" fill="white" />
                                            </g>
                                            <path d="M54.9088 42.582C52.9428 38.311 48.4998 34 42.9998 34C37.4998 34 33.0568 38.311 31.0908 42.582C31.0309 42.7132 31 42.8558 31 43C31 43.1442 31.0309 43.2868 31.0908 43.418C33.0568 47.689 37.4998 52 42.9998 52C48.4998 52 52.9428 47.689 54.9088 43.418C54.9686 43.2868 54.9995 43.1442 54.9995 43C54.9995 42.8558 54.9686 42.7132 54.9088 42.582V42.582ZM42.9998 50C38.5888 50 34.8538 46.448 33.1098 43C34.8538 39.552 38.5888 36 42.9998 36C47.4108 36 51.1458 39.552 52.8898 43C51.1458 46.448 47.4108 50 42.9998 50Z" fill="#607980" />
                                            <path d="M42.9998 38C42.0109 38 41.0442 38.2932 40.2219 38.8427C39.3997 39.3921 38.7588 40.173 38.3804 41.0866C38.0019 42.0002 37.9029 43.0055 38.0958 43.9755C38.2888 44.9454 38.765 45.8363 39.4642 46.5355C40.1635 47.2348 41.0544 47.711 42.0243 47.9039C42.9942 48.0969 43.9995 47.9978 44.9132 47.6194C45.8268 47.241 46.6077 46.6001 47.1571 45.7779C47.7065 44.9556 47.9998 43.9889 47.9998 43C47.9982 41.6744 47.4709 40.4036 46.5335 39.4662C45.5962 38.5289 44.3254 38.0016 42.9998 38V38ZM42.9998 46C42.4064 46 41.8264 45.8241 41.333 45.4944C40.8397 45.1648 40.4552 44.6962 40.2281 44.1481C40.0011 43.5999 39.9416 42.9967 40.0574 42.4147C40.1732 41.8328 40.4589 41.2982 40.8784 40.8787C41.298 40.4591 41.8325 40.1734 42.4145 40.0576C42.9964 39.9419 43.5996 40.0013 44.1478 40.2284C44.696 40.4554 45.1645 40.8399 45.4942 41.3333C45.8238 41.8266 45.9998 42.4067 45.9998 43C45.9998 43.7956 45.6837 44.5587 45.1211 45.1213C44.5585 45.6839 43.7954 46 42.9998 46Z" fill="#607980" />
                                            <defs>
                                              <filter id="filter0_d_1_251" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_251" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_251" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>


                                          <svg className={ShopStyle.HoverBoxWishlist2} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_262)">
                                              <circle cx="43" cy="43" r="23" fill="#607980" />
                                            </g>
                                            <path d="M54.91 42.58C52.94 38.31 48.5 34 43 34C37.5 34 33.06 38.31 31.09 42.58C31.0307 42.7121 31 42.8552 31 43C31 43.1448 31.0307 43.2879 31.09 43.42C33.06 47.69 37.5 52 43 52C48.5 52 52.94 47.69 54.91 43.42C54.9693 43.2879 55 43.1448 55 43C55 42.8552 54.9693 42.7121 54.91 42.58V42.58ZM43 48C42.0111 48 41.0444 47.7068 40.2221 47.1573C39.3999 46.6079 38.759 45.827 38.3806 44.9134C38.0022 43.9998 37.9031 42.9945 38.0961 42.0245C38.289 41.0546 38.7652 40.1637 39.4645 39.4645C40.1637 38.7652 41.0546 38.289 42.0245 38.0961C42.9945 37.9031 43.9998 38.0022 44.9134 38.3806C45.827 38.759 46.6079 39.3999 47.1573 40.2221C47.7068 41.0444 48 42.0111 48 43C47.9984 44.3256 47.4711 45.5964 46.5338 46.5338C45.5964 47.4711 44.3256 47.9984 43 48V48Z" fill="white" />
                                            <path d="M43 46C44.6569 46 46 44.6569 46 43C46 41.3431 44.6569 40 43 40C41.3431 40 40 41.3431 40 43C40 44.6569 41.3431 46 43 46Z" fill="white" />
                                            <defs>
                                              <filter id="filter0_d_1_262" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_262" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_262" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>
                                        </NavLink>
                                      </div>
                                    </div>
                                    <ul onClick={() => history.push("/gemstone-details/" + row.stock_no)}>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Item</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.stock_no}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">
                                          Stone type
                                        </div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.stone_type}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Shape</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.shape}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Carat</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.weight}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Color</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.color}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Clarity</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.clarity}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Cut</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.cut_grade}
                                        </div>
                                      </li>

                                      {/* <li className="rcs_item-lists">
                                                        <div className="rcs_left-align">Measure</div>
                                                        <div className="rcs_right-align">{row.measurements}</div>
                                                    </li> */}
                                      {row.lab == null ? (
                                        ""
                                      ) : (
                                        <li className="rcs_item-lists">
                                          <div className="rcs_left-align">lab</div>
                                          <div className="rcs_center_align">:</div>
                                          <div className="rcs_right-align">
                                            {row.lab}
                                          </div>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="rcs_product_info">
                              <NavLink to={"/gemstone-details/" + row.stock_no}>

                                <h3>{row.name}</h3>
                              </NavLink>
                              <p className="rcs_emailprice rcs_diamonds_price_s">

                                {currency}
                                {row.sale_price}
                              </p>

                            </div>
                          </div>
                        </Col>
                      ))
                    )}
                  </Row>
                  <Row className="mt-5 mb-3">
                    <Col xs={12} lg={6} className="pr-0 m-auto">
                      <div className="rcs_sorting_pagi">
                        <Stack
                          spacing={2}
                          className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                        >
                          <Pagination
                            count={productCount}
                            page={page}
                            onChange={handlePageChange}
                            shape="rounded"
                          />
                        </Stack>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Gemstone;
